export const DEFAULT_INPUT_HEIGHT = 40;
